function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState } from 'react';
import { Button, CustomModal, MenuItem, TextField, Typography, useGlobalContext } from 'seagull';
import { useEventReporter } from "../event-reporter";
import { useRedirectToProposal } from "../hooks/useCreateAgreement";
import { useStore, useStoreActions } from "../store/store-context";
import { SplitButton } from 'seagull/components/SplitButton';
import { MenuList } from '@material-ui/core';
import { routes } from "../constants";
import { useHistory } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { connectControllerToTextField } from "../utils/react-hook-form.utils";
import styles from "./CreateProposalButton.module.scss";
import sortBy from 'lodash/sortBy';
export const CreateProposalButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    reportButtonClick
  } = useEventReporter();
  const {
    openCreationModal
  } = useRedirectToProposal();
  const {
    fetchProposalTemplates
  } = useStoreActions();
  const {
    api
  } = useStoreActions();
  const {
    data: proposalTemplates
  } = useStore(state => state.proposalTemplates);
  const [hasProposalTemplate, setHasProposalTemplates] = useState(false);
  const globalContext = useGlobalContext();
  const history = useHistory();
  useEffect(() => {
    fetchProposalTemplates();
  }, [fetchProposalTemplates]);
  useEffect(() => {
    setHasProposalTemplates(!!(proposalTemplates !== null && proposalTemplates !== void 0 && proposalTemplates.length));
  }, [proposalTemplates]);

  const openNewProposal = async () => {
    reportButtonClick('topbar-new-agreement-btn');
    await openCreationModal();
  };

  const onNewTemplate = async () => {
    const templateId = await globalContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(SelectTemplateModal, {
          dismissModal: dismissModal,
          proposalTemplates: proposalTemplates || []
        });
      }
    });

    if (templateId) {
      const draftId = await api.proposalTemplates.createDraft(templateId);
      history.push(routes.draft(draftId));
    }
  };

  return hasProposalTemplate ? /*#__PURE__*/React.createElement(SplitButton, {
    label: "Create proposal",
    "data-testid": "create-proposal-split-btn",
    onClick: openNewProposal
  }, /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: openNewProposal,
    "data-testid": "new-proposal-option"
  }, "Start from scratch"), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: onNewTemplate,
    "data-testid": "new-template-option"
  }, "Start from template"))) : /*#__PURE__*/React.createElement(Button, {
    "data-testid": "create-proposal-btn",
    onClick: openNewProposal,
    "data-intercom-target": "New Agreement",
    ref: ref
  }, "Create proposal");
});

const SelectTemplateModal = _ref2 => {
  let {
    dismissModal,
    proposalTemplates
  } = _ref2;
  const sortedProposalTemplates = sortBy(proposalTemplates, 'title');
  const {
    control,
    setValue,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      proposalTemplateId: ''
    }
  });

  function onSubmit(_ref3) {
    let {
      proposalTemplateId
    } = _ref3;
    dismissModal(proposalTemplateId);
  }

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(CustomModal, {
    header: /*#__PURE__*/React.createElement("div", {
      className: styles.header
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      weight: "bold"
    }, "Choose template")),
    footer: /*#__PURE__*/React.createElement("div", {
      className: styles.footer
    }, /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      "data-testid": "cancel-button",
      onClick: () => dismissModal()
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "approve-button",
      type: "submit"
    }, "Create proposal")),
    minWidth: 580,
    onClose: () => dismissModal()
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "proposalTemplateId",
    rules: requiredValidation('Please select a template'),
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      select: true,
      placeholder: "Choose a template to start from",
      label: "Template name",
      "data-testid": "template-select"
    }), sortedProposalTemplates.map(_ref4 => {
      let {
        id,
        title
      } = _ref4;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: id,
        value: id,
        "data-testid": "option",
        onClick: () => setValue('proposalTemplateId', id)
      }, title);
    }))
  }))));
};